module.exports = __webpack_public_path__ + "img/hat1_6s_3.debbbcdb.svg";